import { NeutralButton } from "../../common/Buttons"
import useStore from "../../../store"

export default function MarkUnsold() {
  const markUnitUnsold = useStore((state) => state.markUnitUnsold)
  const unit = useStore((state) => state.unit)
  const markingUnitUnSold = useStore((state) => state.markingUnitUnSold)

  return(
    <div className="p-2">
      <NeutralButton
        onClick={() => markUnitUnsold(unit)}
        text="Mark Unsold"
        dataTestId="mark-unsold"
        loading={markingUnitUnSold}
      />
    </div>
  )
}